module.exports = __webpack_public_path__ + "img/Image4.69d71372.png";